import { BaseEntity } from '@models';
import { Type } from 'class-transformer';
import { Organization } from '../organization';
import { SimulationInfrastructure } from './simulation-infrastructure.class';
import { SimulationSavings } from './simulation-savings.class';
import { SimulationStatus } from './simulation-status.enum';

export class Simulation extends BaseEntity {
	createdBy: string;

	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	status: SimulationStatus;
	outDated?: boolean;
	errorMessage?: string;

	@Type(() => SimulationSavings)
	savings: SimulationSavings;

	@Type(() => SimulationInfrastructure)
	infrastructure: SimulationInfrastructure;
}
